export const get = (key: string, defaults: any) => {
  try {
    const data = localStorage.getItem(key)
    if (!data) return defaults
    return JSON.parse(data)
  } catch (error) {
    return defaults
  }
}

export const set = (key: string, data: any) => {
  try {
    data = JSON.stringify(data)
    localStorage.setItem(key, data)
  } catch (error) {
    console.log(error)
  }
}

export const del = (key: string) => {
  localStorage.removeItem(key)
}

export const clear = () => {
  localStorage.clear()
}
